import React, { useEffect } from 'react';
import { CometChatUIKitLoginListener } from '@cometchat/chat-uikit-react';
import { useSearchParams } from 'react-router-dom';
import { CometChatNotifications } from '@cometchat/chat-sdk-javascript';
import { COMETCHAT_CONSTANTS } from 'CometChat/utils/config';
import { __IS_DEV__ } from 'CometChat/utils/env'

export default function RegisterPushToken() {
  const getLoggedInUser = CometChatUIKitLoginListener?.getLoggedInUser();
  const url = new URL(window.location.href);
  const token = url.searchParams.get('token');

  useEffect(() => {
    if (token && getLoggedInUser) {
      CometChatNotifications.registerPushToken(
        token,
        CometChatNotifications.PushPlatforms.FCM_WEB,
        COMETCHAT_CONSTANTS.FCM_PROVIDER_ID
      )
        .then((payload) => {
          console.log('RegisterPushToken success', token);
        })
        .catch((err) => {
          console.log('err', err);
        });
    }
  }, [getLoggedInUser, token]);

  return <></>
}
